import { ShieldCheck } from 'lucide-react'
import { heroContent } from '../../data/homepage'

export interface SiteFooterProps {}

export function SiteFooter(_: Readonly<SiteFooterProps>) {
  return (
    <footer className="site-footer">
      <div className="section-container footer-grid">
        <div className="footer-brand">
          <img src={heroContent.headerLogo} alt="Autoglow Detailing Logo" width="2481" height="785" />
          <p>GYEON ceramic protection specialists in Drysdale, serving Geelong and the Bellarine. Tailored detailing when the vehicle needs it.</p>
        </div>
        <div>
          <h3>Navigation</h3>
          <a href="/">Home</a>
          <a href="/ceramic-protection">Ceramic Protection</a>
          <a href="/paint-correction">Paint Correction</a>
          <a href="/detailing">Detailing</a>
          <a href="/gallery">Gallery</a>
          <a href="/about">About</a>
          <a href="/contact">Contact</a>
        </div>
        <div>
          <h3>Book</h3>
          <a href="/book">Start a booking</a>
          <a href="/contact">Request a quote</a>
        </div>
        <div>
          <h3>GYEON Certified</h3>
          <div className="footer-certified">
            <ShieldCheck size={18} fill="currentColor" aria-hidden="true" />
            <span>Elite Detailer Status</span>
          </div>
          <p>Authorised installer of GYEON ceramic coatings and professional protection systems.</p>
        </div>
      </div>
      <div className="section-container footer-bottom">
        <p>&copy; 2026 Autoglow Detailing | Ceramic protection specialists</p>
        <div>
          <span>EST. 2006</span>
          <span>DRYSDALE - VICTORIA</span>
        </div>
      </div>
    </footer>
  )
}
